import axios from 'axios';
import { BRAND_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const topSaleService = data => {
  return axios({
    method: 'post',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v1/report/top-sale-service', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const topSaleGarment = data => {
    return axios({
      method: 'post',
      url:
        BRAND_BASE_URL +
        '/store/api/secure/v1/report/top-sale-garment', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };